import React, { Component } from 'react';
import {
    Link
} from "react-router-dom";
import { _getLoginStatus, _showOverlay, _hideOverlay, time_out, refresh_time, _clearAllInterval, _clearInterval, _getUserLab, FILE_URL } from './includes/Constants';
import Toast from './includes/Toast';
import withNavigateHook from './includes/withNavigateHook';
import Loader from './includes/Loader';
import LabsHeader from './includes/LabsHeader';
import { _getMedicaltestList, _saveLabTest } from './api/Doctor';
let $ = window.$;
let date = new Date();
const startDate = date;

class ViewLabTest extends Component {
    /**
        * 
        * @param {*} props 
        */
    constructor(props) {
        super(props);

        this.state = {
            user: {},
            list: [],
            medical_test: {},
            default_list: [],
            message: '',
            type: '',
            user_lab: {},
            visibility: 'hide',
            loader: "hide",
            set_interval_ref: 0,
            selected_tests: []     // array to hold selected test keys
        }
    }

    /**
           * 
           * @returns 
           */
    componentDidMount = async () => {
        let res = await _getLoginStatus();
        let medical_test = await this.handleFetchTests();
        //console.log(res);
        if (res['status']) {

            if (res['data']['user_type'] == 'Lab') {
                let res1 = await _getUserLab();

                if (res1['status']) {
                    await this.setState({
                        user_lab: res1.data,
                        user: res.data,
                        medical_test: medical_test
                    });
                } else {
                    await this.setState({
                        user: res.data,
                        medical_test: medical_test
                    });
                }

            } else {
                this.props.navigation('/home');
            }

        } else {
            this.props.navigation('/home');
        }
    }

    /**
        * 
        * @returns 
        */
    _getLabPatientDetails = () => {
        const data = this.props.location.state.data;
        let addedTest=this._getAddedTest(data);
        
        return (
            <div className="card-panel grey lighten-5 z-depth-1">
                <div className="row valign-wrapper">
                    <div className="col s12">
                        <span className="black-text">
                            <p><b>Appointment date:</b>&nbsp;{data.booking_date}</p>
                            <p>
                                <b>Status:</b>&nbsp;
                                <span className={data.status === "Approved" ? 'green-text' : 'red-text'}>
                                    {data.status}
                                </span>
                            </p>
                            <p><b>Name:</b>&nbsp;{data.patient_details.name}</p>
                            <p><b>Age:</b>&nbsp;{data.patient_details.age}&nbsp;years</p>
                            <p><b>Phone Number:</b>&nbsp;{data.patient_details.phone_number}</p>

                            
                            <p><b>Lab Tests:</b>&nbsp;{addedTest.join(', ')}</p>
                             <hr/>
                            <p><b>Select Medical Tests:</b></p>

                            {

                                <form >
                                    <div className="checkbox-row">
                                        {
                                            Object.entries(this.state.medical_test).map(([key, label]) => {
                                                return (
                                                    <label className="checkbox-item" key={key}>
                                                        <input
                                                            type="checkbox"
                                                            name="medical_tests"
                                                            value={key}
                                                            onChange={this.handleCheckboxChange}
                                                            defaultChecked={addedTest.includes(key)}
                                                        />
                                                        <span>{label}</span>
                                                    </label>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className="right-align detailBtn">
                                        <Link to="/" onClick={(e) => this._saveLabTest(e, data)} className="center-align">Save Medical Test</Link>
                                    </div>
                                </form>
                            }
                            <hr/>
                            {
                                data.priscription_image !== null && data.priscription_image !== "" ? (
                                    <p><b>Prescription Image:</b><br />

                                    <div className="dp-div pt-10">
                                    <img
                                            src={FILE_URL + data.priscription_image}
                                            alt=""
                                            className="responsive-img"
                                        />
                                    </div>
                                        
                                    </p>
                                ) : ""
                            }

                        </span>
                    </div>
                </div>
            </div>
        );
    };

    /**
     * 
     * @param {*} data 
     */
    _getAddedTest=(data)=>{
        let testCodes=[];
        testCodes = data.lab_test.map(test => test.test_code);
        return testCodes;
    }

    /**
     * 
     * @param {*} e 
     * @param {*} data 
     */
    _saveLabTest = async(e, data) => {
        e.preventDefault();
        await this.setState({
            loader: "show",
            message: '',
            type: 'success',
            visibility: 'hide'
        })
        // _showOverlay();
        //const data = new FormData(e.target);
        let medical_test = this.state.selected_tests;
         //console.log(medical_test);
         let lab_booking_id = data.id;
        // let res = await this._validateBooking(data);
        if (medical_test.length >0) {

             let reg = await _saveLabTest(lab_booking_id,medical_test);
            if (reg.data.response == 'success') {
                this.setState({

                    message: reg.data.message,
                    type: 'success',
                    visibility: 'show',
                    loader: "hide"
                });
              
                //_hideOverlay();
            } else {
                this.setState({
                    message: reg.data.error,
                    type: 'error',
                    visibility: 'show',
                    loader: "hide"
                });
                //_hideOverlay();
            }

        } else {
            this.setState({
                //error_message: res.error,
                loader: "hide",
                type: 'success',
                visibility: 'hide',
                loader: "hide"
            });
           
        }
    }

    /**
      * 
      * @returns 
      */
    handleFetchTests = async () => {
        let medical_test = {};
        try {
            let res1 = await _getMedicaltestList();

            if (res1.data.response === "success") {
                medical_test = res1.data.result;
            } else {
                console.warn("Failed to fetch medical test list.");
            }
        } catch (error) {
            console.error("Error fetching medical test list:", error);
        }
        return medical_test;
    };



    /**
     * 
     * @param {*} e 
     */
    handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        this.setState(prevState => {
            const selected = new Set(prevState.selected_tests);
            if (checked) {
                selected.add(value);
            } else {
                selected.delete(value);
            }
            return { selected_tests: Array.from(selected) };
        });
    };

    /**
     * 
     * @returns 
     */
    render() {

        return (
            <React.Fragment>
                <LabsHeader />
                <main role="main">
                    <section id="doctor_dashboard-page" className="oparcheecommonCode">
                        <div className="doctor_dashboardContent">
                            <div className="container">
                                <div className="row">
                                    <div className="col s12 mt-10 ">
                                        <div className="strip z-depth-5">
                                            <div className="row">
                                                <div className="col s3 left-align">

                                                    {/* <i className="material-icons">chevron_left</i> */}

                                                </div>
                                                <div className="col s6 center-align">
                                                    <div className="bookingTxt"><h3>
                                                        <i className="material-icons">info</i>&nbsp;
                                                        <span>Patient Lab Details</span></h3></div>
                                                </div>
                                                <div className="col s3 right-align">

                                                    {/* <i className="material-icons">chevron_right</i> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col s12 mt-10">
                                        {this._getLabPatientDetails()}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </section>
                </main>

                <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
            </React.Fragment>
        );
    }
}

export default withNavigateHook(ViewLabTest);
